module.exports = __webpack_public_path__ + "img/fr.c3db3e4b.png";